import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl, blogSorter } from '../../../utils';
import NodeActivityEditor from '../../NodeActivityEditor';
import CommentsIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import SneakPeakIcon from '../../../../public/assets/images/theme-2/icons/toolbar/visible-black.svg';
import { ViewSection, HeaderUserImage, HeaderUserName, HeaderRequestFeedback, SneakPeak } from '../styles';
import { EditorHeaderRowLeft, Editor, EditorHeaderRowRight, BlogWrapper } from '../../NodeActivityEditor/styles';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';

const PublicBlogContentTeacherPanel = ({ fileService, type, reports, student }) => {
  const [hasPeaked, setHasPeaked] = useState([]);

  if (!reports || reports.length === 0) {
    return null;
  }

  const blogReports = reports
    .sort((a, b) => blogSorter(a, b, student))
    .map((report) => {
      const { uuid: entityId, state: reportState, type: entityType, Participation, BlogPosts } = report;
      const { full_name, image, id } = Participation.OrganisationParticipation.User;
      const blog = (BlogPosts?.length > 0 && BlogPosts[0]) || {};
      const { content: reportBody = '', draft: reportDraft = true } = blog || {};
      const workNotStarted = reportState === 'blank' || !reportBody;
      const workInProgress = reportState === 'active' && reportDraft;

      const toggleReportComments = () => {
        document.dispatchEvent(new CustomEvent('toggleComments', { detail: { entityId, entityType } }));
      };

      const sneakPeak = () => {
        const newHasPeacked = [...hasPeaked];
        newHasPeacked.push(id);
        setHasPeaked(newHasPeacked);
      };

      let editorContent = reportBody;
      if (workNotStarted) {
        editorContent = i18n.__('work_not_started');
      } else if (workInProgress && !hasPeaked.includes(id)) {
        editorContent = i18n.__('work_in_progress');
      }

      const headerPanel = (
        <>
          <EditorHeaderRowLeft>
            <HeaderUserImage key={id} src={getImageUrl(fileService, image, '60x60')} title={full_name} />
            <HeaderUserName>{full_name}</HeaderUserName>
          </EditorHeaderRowLeft>
          <EditorHeaderRowRight>
            <ImmersiveReaderButton />
            <HeaderRequestFeedback onClick={toggleReportComments} src={CommentsIcon} />
          </EditorHeaderRowRight>
        </>
      );

      const editorPanel = (
        <Editor
          className="content-section"
          data-selection-entity="blogpost"
          data-selection-uuid={blog?.uuid}
          showStatusText={workNotStarted || (workInProgress && !hasPeaked.includes(id))}
          dangerouslySetInnerHTML={{ __html: editorContent }}
        />
      );

      const sneakPeakPanel =
        workInProgress && !hasPeaked.includes(id) ? (
          <SneakPeak onClick={sneakPeak} src={SneakPeakIcon}>
            {i18n.__('sneak_peak')}
          </SneakPeak>
        ) : null;

      return (
        <BlogWrapper key={id}>
          <NodeActivityEditor
            type={type}
            disabled={true}
            headerPanel={headerPanel}
            editorPanel={editorPanel}
            sneakPeakPanel={sneakPeakPanel}
          />
        </BlogWrapper>
      );
    });

  return <ViewSection>{blogReports}</ViewSection>;
};

export default PublicBlogContentTeacherPanel;

PublicBlogContentTeacherPanel.propTypes = {
  fileService: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  student: PropTypes.object.isRequired,
  reports: PropTypes.array.isRequired,
};
